/* eslint-disable react-hooks/exhaustive-deps */
// src/hooks/useCurrentWeekRange.js

import { useState, useEffect } from "react";
import { getWeeklyMaster } from "../services/forecastService";

export default function useCurrentWeekRange() {
    const [label, setLabel] = useState("Loading week…");

    const ordinal = (n) => {
        const s = ["th", "st", "nd", "rd"], v = n % 100;
        return n + (s[(v - 20) % 10 > 3 ? 0 : v < 4 ? v : 0] || "th");
    };

    const MONTH_IDX = {
        Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
        Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11,
    };

    const parseDM = (dm) => {
        const [d, m] = dm.split("-");
        return new Date(new Date().getFullYear(), MONTH_IDX[m], Number(d));
    };

    useEffect(() => {
        (async () => {
            try {
                const all = await getWeeklyMaster();
                if (!all.length) {
                    setLabel("No weeks found");
                    return;
                }

                const today = new Date();
                // 1) Find the highest wk_no such that any date ≤ today
                let currentWk = 0;
                for (const w of all) {
                    const dt = parseDM(w.dates);
                    if (dt <= today && w.wk_no > currentWk) {
                        currentWk = w.wk_no;
                    }
                }
                if (currentWk === 0) {
                    setLabel("No current week yet");
                    return;
                }

                // 2) Collect that wk_no’s min/max dates
                let minDate = null, maxDate = null, minDM = "", maxDM = "";
                for (const w of all) {
                    if (w.wk_no !== currentWk) continue;
                    const dt = parseDM(w.dates);
                    if (!minDate || dt < minDate) {
                        minDate = dt; minDM = w.dates;
                    }
                    if (!maxDate || dt > maxDate) {
                        maxDate = dt; maxDM = w.dates;
                    }
                }
                if (!minDate || !maxDate) {
                    setLabel(`Week ${currentWk} (no dates)`);
                    return;
                }

                // 3) Format “DD-Mon” → “8th Jun” etc.
                const [mind, minm] = minDM.split("-");
                const [maxd, maxm] = maxDM.split("-");
                setLabel(
                    `Week : ${ordinal(+mind)} ${minm} – ${ordinal(+maxd)} ${maxm}`
                );
            } catch (err) {
                console.error(err);
                setLabel("Error loading week");
            }
        })();
    }, []);

    return label;
}
